import getLangFromCulture from './getLangFromCulture';

const isRtlLang = (culture, rtlLanguages) => {
  const lang = getLangFromCulture(culture);
  return rtlLanguages.includes(lang);
};

export default isRtlLang;
